/* eslint-disable react-hooks/exhaustive-deps */

import { Form, Input, Button, notification } from 'antd';
import IconForgotPassword from './IconForgotPassword';

import AuthService from '../../../services/Auth.service';
import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

const authService = new AuthService();

export default function ForgotPasswordForm(props) {
    const [form] = Form.useForm();

    const { t } = useTranslation();

    const { id } = useParams();

    const messageError = [
        t('passwordPage.ruleTitle'),
        `- ${t('passwordPage.rule1')}`,
        `- ${t('passwordPage.rule2')}`,
        `- ${t('passwordPage.rule3')}`,
        `- ${t('passwordPage.rule4')}`,
    ];

    const strongRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~=!@#$%^&*()_+\-]).{8,}$/;
    const thaiRegex = /^(?=.*[ก-๏])/;

    const checkToken = () => {
        authService
            .checkToken(id)

            .catch(async (err) => {
                //setLoading(false);
                console.log('ERR', err);
                if (err.response.status === 401) {
                    if (await authService.refreshToken()) {
                        return this.getChargerManagement();
                    }
                }
                notification['error']({
                    message: t('passwordPage.SomethingWentWrong'),
                    description: t('passwordPage.PleaseContactWebAdmin'),
                });
            });
    };

    const onFinish = async (values) => {
        await authService
            .newPassword(values.newPassword, values.conPassword, id)
            .then(async (response) => {
                if (response.data.resultMsg === 'SUCCESS') {
                    props.setCurrentPageAction({
                        name: 'SUSSCRESS',
                        mail: '',
                        text: 'RESETPASSWORD',
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                if (err?.response)
                    if (err?.response?.status) {
                        notification['error']({
                            message: t('passwordPage.SomethingWentWrong'),
                            description: t(
                                'passwordPage.PleaseContactWebAdmin'
                            ),
                        });
                    } else {
                        notification['error']({
                            message: t('passwordPage.LoginFail'),
                            description: t(
                                'passwordPage.UsernameOtPasswordNotCorrect'
                            ),
                        });
                    }
            });
    };

    useEffect(() => {
        checkToken();
        try {
            if (localStorage.getItem('Remember') === 'true') {
                form.setFieldsValue({
                    username: localStorage.getItem('username'),
                    password: localStorage.getItem('password'),
                });
            }
            localStorage.removeItem('Remember');
        } catch (err) {
            console.log(err);
        }
    }, []);

    return (
        <div className="justify-center" style={{ width: 700 }}>
            <div
                className="text-4xl mt-16 mb-2 "
                style={{ color: '#A8A8AF', textAlign: 'center' }}
            >
                <IconForgotPassword />
            </div>
            <div
                className="text-2xl  mb-3 pl-16 pr-16"
                style={{ textAlign: 'left' }}
            >
                <span>{t('Reset Password')}</span>
                <br />
            </div>

            <Form
                form={form}
                className="pl-16 pr-16"
                layout="vertical"
                onFinish={onFinish}
                requiredMark={'optional'}
            >
                <span className="whitespace-pre-line">
                    <p style={{ width: 450, marginBottom: 10 }}>
                        {t('passwordPage.ResetDescription')}
                    </p>
                </span>
                <Form.Item
                    hasFeedback
                    name="newPassword"
                    label={
                        <span className="text-xl font-medium">
                            {t('passwordPage.NewPassword')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('passwordPage.NewPasswordIsRequired'),
                        },
                        () => ({
                            validator(_, value) {
                                if (thaiRegex.test(value)) {
                                    return Promise.reject(messageError);
                                } else if (value.length < 8) {
                                    return Promise.reject(messageError);
                                } else if (strongRegex.test(value)) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(messageError);
                            },
                        }),
                    ]}
                >
                    <Input.Password
                        style={{ backgroundColor: '#f5f6ff' }}
                        className="rounded-lg"
                        size="large"
                        placeholder={t('passwordPage.NewPassword')}
                    />
                </Form.Item>
                <Form.Item
                    hasFeedback
                    name="conPassword"
                    label={
                        <span className="text-xl font-medium">
                            {t('passwordPage.ConfirmNewPassword')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t(
                                'passwordPage.ConfirmPasswordIsRequired'
                            ),
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (
                                    !value ||
                                    getFieldValue('newPassword') === value
                                ) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(
                                    new Error(t('errorText.validateConfirm'))
                                );
                            },
                        }),
                    ]}
                >
                    <Input.Password
                        style={{ backgroundColor: '#f5f6ff' }}
                        //prefix={<LockOutlined />}
                        className="rounded-lg"
                        size="large"
                        placeholder={t('passwordPage.ConfirmNewPassword')}
                    />
                </Form.Item>

                <Form.Item className="flex justify-left mb-16">
                    <Button
                        className="flex items-center justify-center mt-6"
                        style={{
                            color: '#fff',
                            backgroundColor: '#7B67FB',
                            width: 150,
                            borderRadius: '7px',
                        }}
                        size="large"
                        htmlType="submit"
                    >
                        {t('common.Confirm')}
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
}
